import * as React from "react";
import { Link } from "@fluentui/react/lib/components/Link/Link";

class AppFeedback extends React.Component {
    render() {
        return (
            <Link href="Mailto:cloudpbxapp.msteams@telekom.de?Subject=Kontaktaufnahme zur Telekom Cloud PBX App">Kontakt</Link>
        );
    }
}

export default AppFeedback;
